import { Controller } from 'stimulus'
import Swiper, { Autoplay, Navigation } from 'swiper'

export default class extends Controller {
  static targets = ['wrapper', 'prevButton', 'nextButton', 'pagination']

  connect() {
    // Initialize Swiper
    const options = {
      loop: this.data.get('hasLoop') === 'true',
      autoplay: this.data.get('autoplay') ? { delay: Number(this.data.get('autoplay')) } : false,

      navigation:
        this.data.get('hasNavigation') === 'true'
          ? {
              nextEl: this.nextButtonTarget,
              prevEl: this.prevButtonTarget,
            }
          : false,
      pagination:
        this.data.get('hasPagination') === 'true'
          ? {
              el: this.paginationTarget,
              clickable: true,
            }
          : false,
      slidesPerView: Number(this.data.get('slidesPerView')) || 'auto',
      spaceBetween: Number(this.data.get('spaceBetween') || 70),
      speed: Number(this.data.get('speed') || 300),
      breakpoints: this.parseBreakpoints(this.data.get('breakpoints')),
    }

    Swiper.use(Navigation)
    Swiper.use(Autoplay)

    this.swiper = new Swiper(this.wrapperTarget, options)
  }

  disconnect() {
    this.swiper.destroy(true, true)
  }

  // eslint-disable-next-line class-methods-use-this
  parseBreakpoints(breakpointsString) {
    return JSON.parse(breakpointsString || '{}')
  }
}
